export default "__VITE_ASSET__DMH$snG5__"